var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /opt/jenkins_home/workspace/marketing-campaigns_deploy_trigger_bcom/916/lib/node_modules/@core/macys-cli/node_modules/core-js/modules/_html.js
// module id = 74
// module chunks = 0